import getters from '@/vuex/modules/ui/colorTheme/getters'
import mutations from '@/vuex/modules/ui/colorTheme/mutations'
import actions from '@/vuex/modules/ui/colorTheme/actions'
import { defaultTheme } from '@/vuex/modules/ui/colorTheme/constants'
const namespaced = true

// 初期stateを設定しないとエラーが起こるので
// デフォルトのテーマを設定しておく
const state = {
  theme: defaultTheme,
  themeList: [],
}

/*
 * 企業ごとにカラーテーマを選択できるが、その切り替えのための状態を管理する
 */
const colorTheme = {
  state: state,
  namespaced: namespaced,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default colorTheme
